import { render } from "./DetalhesTitulo.vue?vue&type=template&id=c73cf42e&scoped=true"
import script from "./DetalhesTitulo.vue?vue&type=script&lang=js"
export * from "./DetalhesTitulo.vue?vue&type=script&lang=js"

import "./DetalhesTitulo.vue?vue&type=style&index=0&id=c73cf42e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c73cf42e"]])

export default __exports__